import React from 'react'
import {lighten, makeStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import FormLabel from '@material-ui/core/FormLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import Modal from '@material-ui/core/Modal'

import Membership from './Membership'
import moment from 'moment'

import clsx from 'clsx'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Switch from '@material-ui/core/Switch'
import DeleteIcon from '@material-ui/icons/Delete'
import FilterListIcon from '@material-ui/icons/FilterList'
import Link from '@material-ui/core/Link'

function descendingComparator(a, b, orderBy) {
  let a0 = a[orderBy]
  let b0 = b[orderBy]
  if (typeof a0 === 'string') {
    a0 = a0.toLowerCase()
  }
  if (typeof b0 === 'string') {
    b0 = b0.toLowerCase()
  }
  if (a0 === undefined) {
    a0 = 'nada'
  }
  if (b0 === undefined) {
    b0 = 'nada'
  }

  if (b0 < a0) {
    return -1
  }
  if (b0 > a0) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

const headCells = [
  {id: 'name', numeric: false, disablePadding: true, label: 'Name'},
  {id: 'email', numeric: false, disablePadding: true, label: 'Email'},
  {id: 'uid', numeric: false, disablePadding: true, label: 'UID'},
  {id: 'endDate', numeric: false, disablePadding: true, label: 'End date'},
  {id: 'membership', numeric: false, disablePadding: true, label: 'membership'},
  {id: 'expiring', numeric: false, disablePadding: true, label: 'expiring'},
]

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{'aria-label': 'select all desserts'}}
          />
        </TableCell>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}))

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles()
  const {numSelected} = props

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}>
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div">
          Members
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton aria-label="filter list">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  )
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    // backgroundColor: 'blue',
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  root: {
    width: '100%',
  },
}))

function MembershipModal(props) {
  const classes = useStyles()
  const {open, setOpen} = props

  const handleOpen = () => {
    props.setOpen(true)
  }

  const handleClose = () => {
    props.setOpen(false)
  }

  return (
    <div>
      <Modal
        open={props.isOpen}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description">
        <div className={classes.paper}>
          <Membership {...props} />
        </div>
      </Modal>
    </div>
  )
}

export default function SpacingGrid() {
  const [users, setUsers] = React.useState([])
  const [memberships, setMemberships] = React.useState([])
  const [membership, setMembership] = React.useState()
  const [user, setUser] = React.useState()
  const [isMembershipModalOpen, setMembershipModalOpen] = React.useState(false)
  const classes = useStyles()
  React.useEffect(() => {
    let userListener, memberListener
    const fetchData = async () => {
      let collectionRef = window.firebaseDb.collection('users')
      let data = []

      userListener = collectionRef.onSnapshot(collectionSnapshot => {
        if (!collectionSnapshot.docs.length) {
          return data
        } else {
          data = collectionSnapshot.docs.map(function (documentSnapshot) {
            return Object.assign({}, documentSnapshot.data(), {
              key: documentSnapshot.id,
            })
          })
          setUsers(data)
        }
      })

      collectionRef = window.firebaseDb.collection('memberships')

      memberListener = collectionRef.onSnapshot(collectionSnapshot => {
        if (!collectionSnapshot.docs.length) {
          return []
        } else {
          data = collectionSnapshot.docs.map(function (documentSnapshot) {
            return Object.assign({}, documentSnapshot.data(), {
              key: documentSnapshot.id,
            })
          })
          setMemberships(data)
        }
      })
    }
    fetchData()
    return () => {
      console.info('cleaning up users')
      userListener && userListener()
      memberListener && memberListener()
    }
  }, [])

  let expiredUsers = []
  let rows = users.map(user => {
    let membership = memberships.filter(m => m.userId === user.uid)[0]
    let endDate =
      (membership && moment(new Date(membership.end.seconds * 1000))) ||
      undefined
    let expiring = false
    let willExpire = false
    let now = moment()
    let monthInMilli = 60 * 60 * 24 * 30 * 1000

    if (membership) {
      let timeLeft = membership.end.seconds * 1000 - now.toDate().getTime()
      if (timeLeft < monthInMilli) {
        willExpire = true
      }
      if (timeLeft < 0) {
        expiring = true
        expiredUsers.push([user, membership])
      }
    }
    let formattedEndDate = endDate && endDate.format('DD/MM/YY')
    let ibanAddress = [
      'IBAN: CH45 0900 0000 3130 3405 0',
      'Nathan Jenkins',
      '13 Rue Maunoir',
      '1207 GE',
    ]
    let emailString = encodeURIComponent(
      [
        `Salut ${user.displayName}!`,
        `Ton abonnement a expiré le ${formattedEndDate}. Si tu veux continuer à grimper à blate,`,
        `s'il te plaît faire un paiement a l'IBAN suivant. Sinon c'est cool si tu rends la cle.`,
        `Si jamais tu pense qu'il y a une erreur n'hesite pas de me contacter.`,
        `Normalement c'est 200CHF/annee mais si tu paye un prix reduit continuer a payer la meme.`,
        ' ',
        ...ibanAddress,
        ' ',
        'cheers',
        'nate',
      ].join('\n'),
    )

    return {
      name: user.displayName,
      email: user.email,
      uid: user.uid,
      endDate: endDate && endDate.format('MM/YY'),
      createdAt: user.createdAt,
      lastAccess: user.lastAccess,
      membershipField: (
        <Button
          onClick={() => {
            console.info('clicked')
            setUser(user)
            setMembership(membership)
            setMembershipModalOpen(true)
          }}>
          {membership ? membership.key : 'create'}
        </Button>
      ),
      membership: membership,
      expiring: expiring,
      willExpire: willExpire,
      emailString: emailString,
    }
  })

  return (
    <Grid container className={classes.root}>
      <MembershipModal
        isOpen={isMembershipModalOpen}
        setOpen={setMembershipModalOpen}
        membership={membership}
        user={user}
      />
      <EnhancedTable rows={rows} />
    </Grid>
  )
}

function EnhancedTable(props) {
  const classes = useStyles()
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('name')
  const [selected, setSelected] = React.useState([])
  const [page, setPage] = React.useState(0)
  const [dense, setDense] = React.useState(false)
  const [rowsPerPage, setRowsPerPage] = React.useState(200)
  const {rows} = props

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangeDense = event => {
    setDense(event.target.checked)
  }

  const sendEmail =
    (email_address, subject, body, user_id, membership) => async event => {
      let url = `mailto:${email_address}?subject=${subject}&body=${body}`
      await window.firebaseDb
        .collection('memberships')
        .doc(membership.key)
        .update({
          expired_email_sent_date: new Date(),
        })
      window.open(url)
    }

  const isSelected = name => selected.indexOf(name) !== -1

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)

  return (
    <div>
      <EnhancedTableToolbar numSelected={selected.length} />
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table">
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {stableSort(rows, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const isItemSelected = isSelected(row.name)
                const labelId = `enhanced-table-checkbox-${index}`
                let rowBackgroundColor
                if (row.expiring) {
                  rowBackgroundColor = 'pink'
                } else if (row.willExpire) {
                  rowBackgroundColor = 'yellow'
                }

                return (
                  <TableRow
                    hover
                    onClick={event => handleClick(event, row.name)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.uid}
                    selected={isItemSelected}
                    style={{backgroundColor: rowBackgroundColor}}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        inputProps={{'aria-labelledby': labelId}}
                      />
                    </TableCell>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      padding="none">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.email}</TableCell>
                    <TableCell align="right">{row.uid}</TableCell>
                    <TableCell align="right">{row.endDate}</TableCell>
                    <TableCell align="right">{row.membershipField}</TableCell>
                    <TableCell align="right">
                      {row.expiring.toString()}
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        onClick={sendEmail(
                          row.email,
                          'renouveler ton abonnement blate',
                          row.emailString,
                          row.uid,
                          row.membership,
                        )}>
                        send email
                      </Button>
                    </TableCell>
                    <TableCell alight="right">
                      {row.membership &&
                        row.membership.expired_email_sent_date &&
                        moment(
                          new Date(
                            row.membership.expired_email_sent_date.seconds *
                              1000,
                          ),
                        ).format('DD/MM/YY')}
                    </TableCell>
                  </TableRow>
                )
              })}
            {emptyRows > 0 && (
              <TableRow style={{height: (dense ? 33 : 53) * emptyRows}}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[200, 300]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/users/Users.js